import React from "react";
import { CircularProgress } from "@mui/material";
import { WithdrawalStatus } from "model/TipCredit";
import { useTips } from "stores/tipsStore/tipsStore";
import { TableRow, TableCell, Box } from "@mui/material";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { getStatusIcon, getStatusStyle } from "utils/creditStatus";

type WithdrawalsTabProps = {
  companyId?: number;
};

export const WithdrawalsTab: React.FC<WithdrawalsTabProps> = (props) => {
  const { withdrawals, updateWithdrawalStatus } = useTips();

  if (!props.companyId) return null;
  if (!withdrawals) return <CircularProgress />;

  return (
    <>
      {withdrawals.map((withdrawal) => (
        <TableRow key={withdrawal.id}>
          <TableCell>{withdrawal.id}</TableCell>
          <TableCell>{withdrawal.amount}</TableCell>
          <TableCell>{withdrawal.reference}</TableCell>
          <TableCell>
            {new Date(withdrawal.createdAt).toLocaleString("sv-SE", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </TableCell>
          <TableCell>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {getStatusIcon(withdrawal.status)}
              <span style={getStatusStyle(withdrawal.status)}>
                {withdrawal.status}
              </span>
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: "flex", gap: 1 }}>
              <ButtonStyled
                onClick={() =>
                  updateWithdrawalStatus(
                    withdrawal.id,
                    WithdrawalStatus.Paid,
                    props.companyId!
                  )
                }
              >
                Pay out
              </ButtonStyled>
              <ButtonStyled
                onClick={() =>
                  updateWithdrawalStatus(
                    withdrawal.id,
                    WithdrawalStatus.Failed,
                    props.companyId!
                  )
                }
              >
                Fail
              </ButtonStyled>
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
